import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { PhoneNumber } from 'src/app/models/data/user';
import { ApiService } from 'src/app/services/api.services';
import { RegisterUserData, StepperDetails } from '../register-user.component';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { PhoneTypeFormComponent } from '../../../components/phones-form/phone-type-form.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { TOSAndPrivacyPolicyComponent } from '../../../terms-of-use-and-privacy-policy/tos-and-privacy-policy.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';

@Component({
	selector: 'app-complete-registration',
	templateUrl: './complete-registration.component.html',
	styleUrls: [
		'./complete-registration.component.scss',
		'../../common/main.scss',
		'../register-user.component.scss',
	],
	imports: [
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		PhoneTypeFormComponent,
		MatCheckbox,
		TOSAndPrivacyPolicyComponent,
		MatButton,
		MatIcon,
		MatMenuTrigger,
		MatMenu,
		MatMenuItem,
	],
})
export class CompleteRegistrationComponent implements OnInit, OnChanges {
	@Input() assignedRoleName = '';
	@Input() assignedCompanyName = '';
	@Input() email = '';
	@Input() firstName = '';
	@Input() lastName = '';
	@Input() token = '';
	@Input() mobilePhoneNumber: PhoneNumber | undefined;
	@Input() userId = '';
	@Input() securityQuestion = '';
	@Input() securityAnswer = '';

	@Output() registerUserData = new EventEmitter<RegisterUserData>();
	@Output() updateStepperDetails = new EventEmitter<StepperDetails>();
	@Output() showMobileVerificationScreen = new EventEmitter<boolean>();

	isNextDisabled = true;
	acceptTerms = false;

	siteLanguage = 'English';
	siteLocale!: string;
	languageList = [
		{ code: 'en-GB', label: 'English (UK)' },
		{ code: 'en-US', label: 'English (US)' },
		/*{ code: 'en-SA', label: 'English (UAE)' },
    { code: 'en-ZA', label: 'English (South Africa)' },
    { code: 'ar-SA', label: 'عربالعربية (المملكة العربية السعودية)' },
    { code: 'ar-AE', label: 'العربية (الإمارات العربية المتحدة)' },
    { code: 'bn', label: 'বাংলা' },
    { code: 'bg', label: 'български' },
    { code: 'cy', label: 'Cymraeg' },
    { code: 'cs', label: 'čeština' },*/
		{ code: 'da', label: 'Dansk' },
		{ code: 'de', label: 'Deutsch' },
		// { code: 'de-AT', label: 'Deutsch (Österreich)' },
		// { code: 'de-BE', label: 'Deutsch (Belgien)' },
		// { code: 'de-LU', label: 'Deutsch (Luxemburg)' },
		// { code: 'de-CH', label: 'Deutsch (Schweiz)' },
		/*{ code: 'et', label: 'eesti keel' },
    { code: 'el', label: 'Ελληνικά' },
    { code: 'el-CY', label: 'Ελληνικά (Κύπρος)' },*/
		{ code: 'es', label: 'Español' },
		/*{ code: 'fil', label: 'Filipino' },*/
		{ code: 'fr', label: 'Français' },
		// { code: 'fr-BE', label: 'Français (Belgique)' },
		// { code: 'fr-LU', label: 'Français (Luxembourg)' },
		// { code: 'fr-CH', label: 'Français (Suisse)' },
		// { code: 'ga-IE', label: 'Gaeilge' },
		// { code: 'gu', label: 'ગુજરાતી' },
		// { code: 'hi', label: 'हिंदी' },
		// { code: 'hr', label: 'Hrvatski' },
		{ code: 'it', label: 'Italiano' },
		// { code: 'it-CH', label: 'Italiano (Svizzera)' },
		// { code: 'lv-LV', label: 'latviski' },
		// { code: 'lt', label: 'lietuvių' },
		// { code: 'hu-HU', label: 'Magyar' },
		// { code: 'mt', label: 'Malti' },
		// { code: 'nl-BE', label: 'Nederlands (België)' },
		{ code: 'nl-NL', label: 'Nederlands' },
		/*{ code: 'pl', label: 'Polskie' },
    { code: 'pt', label: 'Portugues' },
    { code: 'ro-RO', label: 'Română' },
    { code: 'fi', label: 'Suomalainen' },
    { code: 'sl', label: 'Slovenščina' },
    { code: 'sk', label: 'Slovenský' },*/
		{ code: 'sv', label: 'Svenska' },
		// { code: 'sv-FI', label: 'Svenska (Finland)' },
		/*{ code: 'pa', label: 'ਪੰਜਾਬੀ' },*/
		{ code: 'tr', label: 'Türk' } /*,
    { code: 'ur', label: 'اردو' }*/,
	];

	constructor(
		private readonly stepper: MatStepper,
		private readonly apiService: ApiService
	) {}

	ngOnInit(): void {
		this.siteLocale = window.location.pathname.split('/')[1];
		this.siteLanguage =
			this.languageList.find((f) => f.code === this.siteLocale)?.label ??
			this.languageList[0].label;
	}

	ngOnChanges(): void {
		this.disableNextButton();
	}

	updateUserPhone(mobilePhone: PhoneNumber): void {
		this.mobilePhoneNumber = mobilePhone;
	}

	disableNextButton(): void {
		if (!this.firstName || !this.lastName || !this.acceptTerms) {
			this.isNextDisabled = true;
		} else {
			this.isNextDisabled = false;
		}
	}

	async onNextClicked(): Promise<void> {
		// if we don't have a phone number at all or if the phone number has less than 4 digits (not a valid phone number and
		// likely is only the contry code) then we will skip the mobile verification step.
		if (
			this.mobilePhoneNumber?.rawPhoneNumber === undefined ||
			this.mobilePhoneNumber?.rawPhoneNumber.length < 4
		) {
			this.updateStepperDetails.emit({ stepProgress: '50', stepCount: '3' });
			this.showMobileVerificationScreen.emit(false);
		} else {
			await this.apiService
				.requestPhoneVerificationCode(
					this.userId,
					this.mobilePhoneNumber.rawPhoneNumber
				)
				.then((_) => {
					this.updateStepperDetails.emit({
						stepProgress: '30',
						stepCount: '2',
					});
					this.showMobileVerificationScreen.emit(true);
				});
		}

		this.registerUserData.emit({
			email: this.email,
			firstName: this.firstName,
			lastName: this.lastName,
			assignedRoleName: this.assignedRoleName,
			assignedCompanyName: this.assignedCompanyName,
			mobilePhoneNumber: this.mobilePhoneNumber,
			token: this.token,
			userId: this.userId,
			securityQuestion: this.securityQuestion,
			securityAnswer: this.securityAnswer,
		});
		this.stepper.next();
	}
}
